import React from 'react';
import { FaCheckCircle, FaRobot, FaFish } from 'react-icons/fa';

export default function CommunityBadge({ role }) {
  if (!role) return null;

  switch (role) {
    case 'Verified Bass Boat Operator':
      return (
        <span className="community-badge badge-operator">
          <FaCheckCircle /> Verified Operator
        </span>
      );
    case 'Fishing Guide':
      return (
        <span className="community-badge badge-guide">
          <FaFish /> Pro Guide
        </span>
      );
    case 'AI Assistant':
      return (
        <span className="community-badge badge-ai">
          <FaRobot /> AI Bot
        </span>
      );
    default:
      return null;
  }
}
